import { proxy } from "valtio";
import { devtools } from "valtio/utils";

import { POSITION_BOTTOM } from "@constants/index";

const ENV_DEV = "dev";
const ENV_RECETTE = "recette";

type QrCodeType = "url" | "image";

type DiversStoreType = {
    centralizedPrintingPrintOtherPeople: boolean;
    standAlonePrintingStationPrints: boolean;
    printingOptionsA4Format: boolean;
    printingOptionsPrintingProcess: boolean;
    printingOptionsSpecialCharacters: boolean;
    printingOptionsInstalledPrinter: boolean;
    printingOptionsForcePaper: boolean;
    printingOptionsDeportedServer: boolean;
    pendingBarcodeChecked: boolean;
    pendingBarcodePosition: string;
    pendingQrCodeChecked: boolean;
    pendingQrCodePosition: string;
    orderBarcodeChecked: boolean;
    orderBarcodePosition: string;
    orderQrCodeChecked: boolean;
    orderQrCodePosition: string;
    paperlessTicket: boolean;
    qrCodeType: QrCodeType;
    qrCodeUrl: string;
    qrCodeImage: string;
};

const DIVERS_DEFAULTS: DiversStoreType = {
    centralizedPrintingPrintOtherPeople: false,
    standAlonePrintingStationPrints: false,
    printingOptionsA4Format: false,
    printingOptionsPrintingProcess: false,
    printingOptionsSpecialCharacters: false,
    printingOptionsInstalledPrinter: false,
    printingOptionsForcePaper: false,
    printingOptionsDeportedServer: false,
    pendingBarcodeChecked: false,
    pendingBarcodePosition: POSITION_BOTTOM,
    pendingQrCodeChecked: false,
    pendingQrCodePosition: POSITION_BOTTOM,
    orderBarcodeChecked: false,
    orderBarcodePosition: POSITION_BOTTOM,
    orderQrCodeChecked: false,
    orderQrCodePosition: POSITION_BOTTOM,
    paperlessTicket: false,
    qrCodeType: "url",
    qrCodeUrl: "",
    qrCodeImage: "",
};

export const diversStore = proxy<DiversStoreType>({ ...DIVERS_DEFAULTS });

if (
    process.env.REACT_APP_VERIFY === ENV_DEV ||
    process.env.REACT_APP_VERIFY === ENV_RECETTE
) {
    devtools(diversStore);
}

export function setCentralizedPrintingPrintOtherPeople(value: boolean): void {
    diversStore.centralizedPrintingPrintOtherPeople = value;
}
export function setStandAlonePrintingStationPrints(value: boolean): void {
    diversStore.standAlonePrintingStationPrints = value;
}
export function setPaperlessTicket(value: boolean): void {
    diversStore.paperlessTicket = value;
}
export function setPrintingOptionsA4Format(value: boolean): void {
    diversStore.printingOptionsA4Format = value;
}
export function setPrintingOptionsPrintingProcess(value: boolean): void {
    diversStore.printingOptionsPrintingProcess = value;
}
export function setPrintingOptionsSpecialCharacters(value: boolean): void {
    diversStore.printingOptionsSpecialCharacters = value;
}
export function setPrintingOptionsInstalledPrinter(value: boolean): void {
    diversStore.printingOptionsInstalledPrinter = value;
}
export function setPrintingOptionsForcePaper(value: boolean): void {
    diversStore.printingOptionsForcePaper = value;
}
export function setPrintingOptionsDeportedServer(value: boolean): void {
    diversStore.printingOptionsDeportedServer = value;
}
export function setPendingBarcodeChecked(value: boolean): void {
    diversStore.pendingBarcodeChecked = value;
}
export function setPendingBarcodePosition(value: string): void {
    diversStore.pendingBarcodePosition = value;
}
export function setPendingQrCodeChecked(value: boolean): void {
    diversStore.pendingQrCodeChecked = value;
}
export function setPendingQrCodePosition(value: string): void {
    diversStore.pendingQrCodePosition = value;
}
export function setOrderBarcodeChecked(value: boolean): void {
    diversStore.orderBarcodeChecked = value;
}
export function setOrderBarcodePosition(value: string): void {
    diversStore.orderBarcodePosition = value;
}
export function setOrderQrCodeChecked(value: boolean): void {
    diversStore.orderQrCodeChecked = value;
}
export function setOrderQrCodePosition(value: string): void {
    diversStore.orderQrCodePosition = value;
}
export function setQrCodeType(value: QrCodeType): void {
    diversStore.qrCodeType = value;
}
export function setQrCodeUrl(value: string): void {
    diversStore.qrCodeUrl = value;
}
export function setQrCodeImage(value: string): void {
    diversStore.qrCodeImage = value;
}

export function resetDiversStore(): void {
    Object.assign(diversStore, DIVERS_DEFAULTS);
}
